import { ComponentProps } from "react";

const CircleSendIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none" {...props}>
      <circle opacity="0.15" cx="36" cy="36" r="36" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2398 37.0264C35.2398 37.0264 17.2749 32.8381 23.5178 28.7767C28.786 25.3496 46.9419 19.4573 49.4784 20.9798C50.8293 23.8383 45.601 44.2998 42.5601 50.237C38.9562 57.2727 35.2398 37.0264 35.2398 37.0264Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2397 37.0264L49.4783 20.9798"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleSendIcon;
